export const QueryTags = {
  DoorCostList: 'DoorCostList',
  DoorCostDetail: 'DoorCostDetail',
  UserDetail: 'User',
  CrewMembersProfilesList: 'CrewMembersProfilesList',
  AvailableCrewMembersList: 'AvailableCrewMembersList',
  OnLeaveCrewMembersList: 'OnLeaveCrewMembersList',
};
